export default __webpack_public_path__ + "static/media/newSplashScreen.c1daea15.png";